import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GET_ALTENATE_REQUEST_EVENT, IGetAlternateRequestEvent } from '@df/core/meta/meta-alternate.service';
import { Events } from '@df/core/service/event';

/**
 * Plugin for meta data
 */
@Injectable({
    providedIn: 'root'
})
export class FacetUrlMetaAlternatePluginService {
    private events = inject(Events);
    private destroyRef = inject(DestroyRef);

    appInitialize() {
        this.patchGetAlternateRequest();
    }

    private patchGetAlternateRequest() {
        this.events
            .on(GET_ALTENATE_REQUEST_EVENT)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((event: IGetAlternateRequestEvent) => {
                const facetData = event.route?.data?.facet;

                if (facetData) {
                    event.request.type = 'facet';
                    event.request.filter = facetData.filter;
                }
            });
    }
}
